import React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    required, BooleanField, Datagrid,
    ArrayField, ReferenceField,
} from 'react-admin';

const UserShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="username" validate={[required()]}/>
            <BooleanField source="enable"/>
            <DateField source="lastLogin" showTime locales="es-AR"/>
            <TextField source="matricula" />
            <ArrayField source="roles" addLabel={false}>
                <Datagrid>
                    <ReferenceField source="roleId" reference="roles" label="resources.users.fields.roles" linkType={false}>
                        <TextField source="description"/>
                    </ReferenceField>
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
);
export default UserShow;
